import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import get from 'lodash/get';

@Component({
  selector: 'app-multi-select-search',
  templateUrl: './multi-select-search.component.html',
  styleUrls: ['./multi-select-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class MultiSelectSearchComponent
  implements OnInit, AfterViewInit, OnDestroy, OnChanges
{
  @ViewChild('multiSelect', { static: true }) multiSelect: MatSelect;

  /** list of items */
  @Input() items: any = [];
  @Input() initialState: any[] = [];
  @Input() uppercase = false;
  @Output() searchValue = new EventEmitter<string>();

  /** control for the selected bank for multi-selection */
  public itemsMultiCtrl: FormControl = new FormControl();

  /** control for the MatSelect filter keyword multi-selection */
  public itemsMultiFilterCtrl: FormControl = new FormControl();

  /** list of banks filtered by search keyword */
  public filteredItemsMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);

  @Input() placeholder: string;

  protected _onDestroy = new Subject<void>();

  ngOnInit() {
    this.filteredItemsMulti.next(this.items.slice());

    this.itemsMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterItemsMulti();
      });
  }

  ngAfterViewInit() {
    this.setInitialValue();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.initialState) {
      this.itemsMultiCtrl.setValue(
        get(changes, 'initialState.currentValue', [])
      );
    }

    if (changes.items) {
      this.items = get(changes, 'items.currentValue', []);
      this.filteredItemsMulti.next(this.items.slice());
    }
  }

  protected setInitialValue() {
    this.filteredItemsMulti
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(() => {
        // setting the compareWith property to a comparison function
        // triggers initializing the selection according to the initial value of
        // the form control (i.e. _initializeSelection())
        // this needs to be done after the filteredBanks are loaded initially
        // and after the mat-option elements are available
        this.multiSelect.compareWith = (a: any, b: any) =>
          a && b && a.id === b.id;
      });
  }

  protected filterItemsMulti() {
    if (!this.items) {
      return;
    }
    // get the search keyword
    let search = this.itemsMultiFilterCtrl.value;
    if (!search) {
      this.filteredItemsMulti.next(this.items.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filteredItemsMulti.next(
      this.items.filter((item) => item.name.toLowerCase().indexOf(search) > -1)
    );
  }

  ngOnDestroy() {
    this._onDestroy.next(null);
    this._onDestroy.complete();
  }

  setFilter() {
    this.searchValue.emit(this.itemsMultiCtrl.value);
  }
}
